<template>
  <div>
    <div
      class="qt-shadow-box accordion-box"
      v-for="(project, index) in projects"
      :key="index"
      :class="{ active: project.expanded,'currentactive': hasOpenStatus(project), 'current': !hasOpenStatus(project) }"
    >
      <div class="accordion-header">
        <h4 class="qt-project-head">{{ project.projectName }}  <span></span></h4>
       
      </div>
      <div class="accordion-content" :style="{ maxHeight: project.expanded ? contentHeight + 'px' : '0' }" ref="content">
        <div class="qt-full-table scrollable-table">
          <table>
            <tr>
              <th>Details</th>
              <th>Project Engagement Level</th>
              <th>Employee Name</th>
              <th>INT/EXT</th>
              <th>Qemployment</th>
              <th>Project Time Forecast</th>
              <th>Time recordings</th>
              <th>Time Spent %</th>
              <th>Available Time</th>
              <th>Time Release Status</th>
            </tr>
            <tr v-for="(data, dataIndex) in project.projectData" :key="dataIndex">
              <td>{{ data.positionName }}</td>
              <td>{{ (data.projecEngagement || 0).toFixed(2) }} %</td>
              <td>{{ data.employeeName }}</td>
              <td>{{ data.intorExt }}</td>
              <td>{{ (data.qEmployment || 0).toFixed(2) }} %</td>
              <td>{{ (data.projectTimeForecast || 0).toFixed(2) }}</td>
              <td>{{ (data.timeRecordings || 0).toFixed(2) }} hrs</td>
              <td>{{ (data.timeSpent || 0).toFixed(2) }}</td>
              <td>{{ (data.availableTime || 0).toFixed(2) }}</td>
              <td :class="{'qt-red-text': data.status === 'Open', 'qt-green-text': data.status !== 'Open'}">{{ data.status === 'Open'? 'Not released' : data.status }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="no-item" v-if="projects.length < 1">No items found !</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      projects: [],
      contentHeight: 0,
    };
  },
  methods: {
    toggleAccordions(){
    setTimeout(function(){
      const accordionItems = document.querySelectorAll('.accordion-box');

  // Add click event listener to each accordion header
  accordionItems.forEach((item, index) => {
  const header = item.querySelector('.accordion-header');
  const content = item.querySelector('.accordion-content');
  header.addEventListener('click', () => {
      // Check if the clicked section is already active
      const isActive = item.classList.contains('active');

      // Open the clicked section if it wasn't active

      if (!isActive) {

          item.classList.add('active');

          content.style.maxHeight = content.scrollHeight + 'px';

      } else {

          item.classList.remove('active');

          content.style.maxHeight = null;

      }

  });
  
  });
    }, 1000)
   
  },
    hasOpenStatus(project) {
    return project.projectData.some((data) => data.status === 'Open');
    }
  },
  updated(){
  this.toggleAccordions();
},
  beforeMount(){
    this.$store.dispatch("DMExternalProjectOverview").then(() => {
    // Retrieve the fetched data from the store
    this.projects = this.dmExternalProjectOverview;
debugger
    this.projects.forEach((project) => {
      project.expanded = false;
    });
  });
  },
  computed: {
      dmExternalProjectOverview: function () {
              return this.$store.state.qtimeReports.dmExternalProjectOverview;
          }
  }
};
</script>